import React from 'react';
import ButtonMUI from '@mui/material/Button';

const notDarkStyles = {
  backgroundColor: '#f5f5f5',
  color: 'rgba(14, 41, 64, 0.97)',
  fontWeight: 'bold',
  textTransform: 'none',
  boxShadow: 'none',

  '&:hover': {
    backgroundColor: '#f5f5f5',
    boxShadow: 'none',
  },
  '&:active': {
    backgroundColor: '#f5f5f5',
    boxShadow: 'none',
  },
  '&.Mui-focusVisible': {
    backgroundColor: '#f5f5f5',
  },
};

const darkStyles = {
  backgroundColor: 'rgba(14, 41, 64, 0.97)',
  color: '#f5f5f5',
  fontWeight: 'bold',
  textTransform: 'none',
  boxShadow: 'none',

  '&:hover': {
    backgroundColor: 'rgba(14, 41, 64, 0.85)',
    boxShadow: 'none',
  },
  '&:active': {
    backgroundColor: 'rgba(14, 41, 64, 0.85)',
    boxShadow: 'none',
  },
};

const outlinedStyles = {
  backgroundColor: '#f5f5f5',
  border: '1px solid rgba(14, 41, 64, 0.97)',
  color: 'rgba(14, 41, 64, 0.97)',
  fontWeight: 'bold',
  textTransform: 'none',
  boxShadow: 'none',

  '&:hover': {
    backgroundColor: 'rgba(14, 41, 64, 0.05)',
    boxShadow: 'none',
  },
};

export default function Button({
  isDark = true,
  isOutlined = false,
  label,
  ...rest
}) {
  const sxStyles = isOutlined
    ? outlinedStyles
    : isDark
    ? darkStyles
    : notDarkStyles;

  return (
    <div className="button-container little-grow-animation">
      <ButtonMUI
        variant={isOutlined ? 'outlined' : 'contained'}
        disableElevation
        sx={sxStyles}
        {...rest}
      >
        {label}
      </ButtonMUI>
    </div>
  );
}
